export default "__VITE_ASSET__467af7d0__"